<template>
	<v-dialog
		v-model="dialog"
		persistent
		max-width="350"
		transition="scroll-x-reverse-transition">
		<template #activator="{ on, attrs }">
			<v-list-item v-if="listItem"
				color="danger"
				:class="classes"
				v-bind="attrs"
				v-on="on">
				<v-list-item-icon><v-icon color="red">mdi-delete</v-icon></v-list-item-icon>
				<v-list-item-content class="red--text"><slot /></v-list-item-content>
			</v-list-item>
			<v-btn v-else
				:class="classes"
				color="red"
				:small="small"
				:x-small="xSmall"
				:disabled="disabled"
				:text="text"
				:plain="plain"
				:icon="icon"
				:block="block"
				elevation="0"
				:dark="! disabled"
				v-bind="attrs"
				v-on="on">
				<slot />
			</v-btn>
		</template>
		<v-card>
			<v-card-title class="text-h5">
				Are you sure?
			</v-card-title>
			<v-card-text class="pt-5" style="font-size: 105%">{{ warning }}</v-card-text>
			<v-divider />
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
					color="gray lighten-2"
					text
					small
					class="grey--text text--darken-1"
					@click="dialog = false">
					Cancel
				</v-btn>
				<v-btn
					class="red darken-1"
					dark
					depressed
					small
					:loading="submitted"
					@click="handleDelete">
					<v-progress-circular
						v-if="submitted"
						indeterminate
						class="mr-2"
						size="20"
						color="white">
					</v-progress-circular>
					<span v-if="!submitted">Delete</span>
					<span v-else>Deleting</span>
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
export default {
	props: {
		model: {
			type: String,
			default: null
		},
		modelId: {
			type: Number,
			default: null
		},
		modelIds: {
			type: Array,
			default: () => []
		},
		classes: {
			type: String,
			default: ''
		},
		small: {
			type: Boolean,
			default: false
		},
		xSmall: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		text: {
			type: Boolean,
			default: false
		},
		icon: {
			type: Boolean,
			default: false
		},
		block: {
			type: Boolean,
			default: false
		},
		plain: {
			type: Boolean,
			default: false
		},
		listItem: {
			type: Boolean,
			default: false
		},
		warning: {
			type: String,
			default: 'This action cannot be undone!'
		},
		only: {
			type: Array,
			default: () => []
		}
	},
	data () {
		return {
			dialog: false,
			submitted: false
		}
	},
	methods: {
		handleDelete () {
			let route
			let data = {}
			this.$emit('deleting')
			this.submitted = true

			if (this.modelId) {
				route = this.route(this.model + '.destroy', this.modelId)
			} else if (this.modelIds && this.length(this.modelIds)) {
				route = this.route(this.model + '.destroy')
				data['ids'] = this.modelIds
			}

			this.$inertia.delete(route, {
				data: data,
				only: this.only,
				preserveScroll: true,
				onError: (errors) => {
					this.$emit('error', errors)
					this.submitted = false
				},
				onSuccess: () => {
					// WARNING: If the delete action also removes this component, this emit event will never fire
					this.$emit('deleted')
					this.submitted = false
				},
				onFinish: () => {
					this.dialog = false
					this.submitted = false
				}
			})
		}
	}
}
</script>
